<template>
  <div v-if="!!entity">
    <div class="row mb-3 mt-3">
      <div class="col-sm-4"><h1></h1></div>
      <div class="col-sm-4 d-none d-lg-block"><h3>Objekt</h3></div>
      <div class="col-sm-4 text-end" v-if="canChange">
        <router-link
          :to="{ name: 'CustomerEdit', params: { customerId: entity.customerID } }"
          v-if="entity.customerID"
          class="link-warning ms-3"
          >Stranka</router-link
        >
      </div>
    </div>
    <fieldset :disabled="!canChange" class="border-0 p-0 m-0">
      <div class="row mb-3">
        <div class="col-md-8">
          <div class="row mb-3" v-show="!isNew">
            <label class="form-check-label col-sm-4" for="is-active">Aktiven</label>
            <div class="col-sm-8">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="is-active" v-model="entity.isActive" />
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <label class="col-form-label col-sm-4">Naziv</label>
            <div class="col-sm-8">
              <input class="form-control" type="text" v-model="entity.name" required />
            </div>
          </div>
          <div class="row mb-3">
            <label class="col-form-label col-sm-4">Stranka</label>
            <div class="col-sm-8">
              <SelectEntity apiEntity="DropDown/Customers" v-model="entity.customerID" required />
            </div>
          </div>
          <div class="row mb-3">
            <label class="col-form-label col-sm-4">Naslov</label>
            <div class="col-sm-8">
              <input class="form-control" type="text" v-model="entity.address" required />
            </div>
          </div>
          <div class="row mb-3">
            <label class="col-form-label col-sm-4">Poštna številka</label>
            <div class="col-sm-2">
              <input class="form-control" type="text" v-model="entity.postCode" required />
            </div>
          </div>
          <div class="row mb-3">
            <label class="col-form-label col-sm-4">Kraj</label>
            <div class="col-sm-8">
              <input class="form-control" type="text" v-model="entity.postCity" required />
            </div>
          </div>
          <div class="row mb-3">
            <label class="col-form-label col-sm-4">Referenca stranke (unikatno!)</label>
            <div class="col-sm-8">
              <input class="form-control" type="text" v-model="entity.facilityNumber" />
            </div>
          </div>
          <div class="row mb-3">
            <label class="col-form-label col-sm-4">Lat (45 do 47)</label>
            <div class="col-sm-4">
              <input class="form-control" pattern="[0-9.]+" type="number" step="any" v-model="entity.lat" required />
            </div>
          </div>
          <div class="row mb-3">
            <label class="col-form-label col-sm-4">Lng (13 do 17)</label>
            <div class="col-sm-4">
              <input class="form-control" pattern="[0-9.]+" type="number" step="any" v-model="entity.lng" required />
            </div>
          </div>
          <div class="row mb-3">
            <label class="col-form-label col-sm-4">Emaili prejemnikov ponudb</label>
            <div class="col-sm-8">
              <input
                class="form-control"
                :class="{ 'is-invalid': !areOfferRecipientsValid }"
                type="text"
                v-model="entity.offerRecipients"
              />
              <div class="invalid-feedback">
                Prosimo, vnesite veljavne email naslove, ločene z vejico ali podpičjem.
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <label class="col-form-label col-sm-4">Posebnosti</label>
            <div class="col-sm-8">
              <textarea class="form-control" rows="6" v-model="entity.peculiarities"></textarea>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-form-label col-3 col-sm-4">Požarna ogroženost</div>
            <div class="col-9 col-sm-8">
              <IntegerRadioGroup
                v-model="entity.fireWatchLevel"
                :canChange="canChange"
                :numberOfValues="6"
                namePrefix="facilityFireWatchLevel"
              />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card mb-3" v-if="!isNew && !editFacilityContacts">
            <div class="card-body">
              <h5 class="card-title">
                Podpisniki
                <button class="btn btn-sm btn-outline-info" @click="editFacilityContacts = true" v-if="canChange">
                  Urejaj
                </button>
              </h5>
              <ul>
                <li v-for="c in entity.contacts" class="mt-1">{{ c.name }} [{{ c.email }}]</li>
              </ul>
            </div>
          </div>

          <div class="card mb-3" v-if="!isNew && editFacilityContacts && canChange">
            <div class="card-body">
              <h5 class="card-title">Podpisniki</h5>
              <ul>
                <li v-for="c in entity.contacts" class="mt-1">
                  {{ c.name }} [{{ c.email }}]
                  <button class="btn btn-sm btn-outline-danger" @click="localDeleteFacilityContactAsync(c)">
                    Odstrani
                  </button>
                </li>
              </ul>
              <hr />
              <FacilityContactEdit v-model="facilityContact" @save="localSaveFacilityContactAsync(facilityContact)" />
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <RequiredWarning v-show="canChange && !isValid" />

    <div class="row mb-5">
      <div class="col-2 text-start"></div>
      <div class="col-10 text-end">
        <a
          class="me-3"
          role="button"
          @click="
            $router.push({
              name: 'DeviceEdit',
              params: { deviceId: 'new', customerId: entity.customerID, facilityId: entity.id },
            })
          "
          v-show="!isNew && canChange"
          >Nova naprava</a
        >
        <button class="btn btn-outline-secondary me-3" type="button" @click="$router.push({ name: 'Facilities' })">
          Prekliči
        </button>
        <button
          class="btn btn-success btn-lg me-3"
          type="button"
          @click="saveAsync"
          :disabled="!canChange || !isValid"
          v-if="canChange"
        >
          Shrani
        </button>
      </div>
    </div>

    <div class="row mb-4" v-if="!isNew">
      <div class="col-12">
        <div class="border rounded bg-white p-3">
          <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
            <h5 class="mb-0">Priloge</h5>
            <button class="btn btn-warning btn-sm" @click="showUpload = true" v-if="canChange">
              Naloži datoteko tipa <strong>{{ attachmentTypeLabel }}</strong>
            </button>
          </div>

          <ul class="nav nav-tabs mb-3">
            <li class="nav-item" v-for="[typeKey, typeLabel] in attachmentTypes">
              <button
                class="nav-link"
                :class="{ active: attachmentTypeFilter === typeKey }"
                type="button"
                @click="attachmentTypeFilter = typeKey"
              >
                {{ typeLabel }}
              </button>
            </li>
          </ul>
          <div>
            <Attachments
              :attachments="attachments"
              :showDate="true"
              :showTime="true"
              :showDelete="$hasRole(role, ['LeaderService', 'Administrator'])"
              @delete="
                (e) => {
                  deleteAttachment(e)
                }
              "
              :filterByType="attachmentTypeFilter"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5" v-show="!isNew">
      <div class="col">
        <ServiceOrdersCard
          class="card mb-3"
          :facilityID="entity.id"
          :showLinkToMap="false"
          statuses="Completed,Finalized"
          title="Delovni nalogi"
          subTitle="Completed,Finalized"
        />
      </div>
      <div class="col">
        <ProjectsCard
          class="card mb-3"
          v-if="!$hasRole(role, ['Customer'])"
          :projects="projects"
          :pagingData="projectPaging"
          subTitle="Finalized,Completed"
        />

        <div class="card mb-3">
          <div class="card-body">
            <h5 class="card-title d-none d-lg-block">Kontrolni listi</h5>
            <ul>
              <!-- todo: duplicates around the app RAFACTOR -->
              <li v-for="cr in entity.devices.map((d) => d.checklists).flat()">
                <a
                  v-if="cr.type === 'CalibrationReport'"
                  :href="$AZURE_URI + '/Generated/CalibrationReport/' + cr.serviceOrderID + '?deviceId=' + cr.deviceID"
                  target="_blank"
                  >{{ $dayjs(cr.dateCreated).format($DATE_FORMAT_DISPLAY) }}</a
                >
                <a
                  v-else-if="cr.type === 'SystemReport'"
                  :href="$AZURE_URI + '/Generated/SystemReport/' + cr.serviceOrderID + '?deviceId=' + cr.deviceID"
                  target="_blank"
                >
                  Kontrola delovanja hladilnega sistema {{ $dayjs(cr.dateCreated).format($DATE_FORMAT_DISPLAY) }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5" v-show="!isNew && entity.devices?.length > 0">
      <div class="col">
        <DeviceList
          :devices="entity.devices"
          :showType="true"
          :enableDepth="true"
          :showFacility="false"
          :editDates="true"
          :showSupplier="false"
        />
        <div class="text-end mt-2">
          <button class="btn btn-success" type="button" @click="saveDeviceDatesAsync">Shrani datume</button>
        </div>
      </div>
    </div>

    <Upload
      v-if="canChange"
      :visible="!!showUpload"
      @close="showUpload = false"
      @add="
        (e) => {
          addAttachment(e)
        }
      "
      type="Facility"
      :attachmentType="attachmentTypeFilter"
      :id="entity.id"
    />
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import {
  getFacilityAsync,
  saveEntityAsync,
  listEntitiesAsync,
  saveFacilityContactAsync,
  deleteFacilityContactAsync,
} from "../api"
import { EMPTY_GUID } from "../utils/constants"
import { useAuth, role } from "../composition-api/useAuth"
import DeviceList from "../components/DeviceList.vue"
import FacilityContactEdit from "../components/FacilityContactEdit.vue"
import { useAttachments } from "../components/useAttachments"
import { useProjects, ProjectsCard } from "../composition-api/useProjects"
import { useEnums } from "../composition-api/useEnums"
import ServiceOrdersCard from "../components/ServiceOrdersCard.vue"

defineOptions({ name: "FacilityEdit" })

const route = VueRouter.useRoute()
const router = VueRouter.useRouter()
const { fetchAuthAsync } = useAuth()
const { attachments, addAttachment, deleteAttachment } = useAttachments()
const { attachmentTypes, loadEnumsAsync } = useEnums()
const showUpload = ref(false)
const attachmentTypeFilter = ref("FacilityDocumentation")
const attachmentTypeLabel = computed(
  () => attachmentTypes.value.get(attachmentTypeFilter.value) || attachmentTypeFilter.value,
)
const { resetPaging: resetProjectPaging, filters: projectFilters, projects, paging: projectPaging } = useProjects()
const isCustomer = computed(() => !!role.value && role.value.startsWith("Customer"))
const canChange = computed(() => !isCustomer.value)
const canViewProjects = computed(() => !isCustomer.value)

const facilityContact = ref({})
const entity = ref()
const editFacilityContacts = ref(false)

const isNew = computed(() => route.params.facilityId === "new")

const areOfferRecipientsValid = computed(() => {
  if (!entity.value?.offerRecipients) {
    return true
  }
  const emails = entity.value.offerRecipients
    .split(/[,;]/)
    .map((e) => e.trim())
    .filter((e) => e.length > 0)
  if (emails.length === 0) {
    return true
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emails.every((email) => emailRegex.test(email))
})

const isValid = computed(
  () =>
    entity.value?.name?.length > 0 &&
    entity.value?.address?.length > 0 &&
    entity.value?.postCode?.length > 0 &&
    entity.value?.postCity?.length > 0 &&
    entity.value.customerID !== EMPTY_GUID &&
    entity.value?.lat >= 45 &&
    entity.value?.lat < 47 &&
    entity.value?.lng >= 13 &&
    entity.value?.lng < 17 &&
    areOfferRecipientsValid.value,
)

const loadEntityAsync = async () => {
  entity.value = await getFacilityAsync(fetchAuthAsync, route.params.facilityId, true)
  attachments.value = entity.value?.attachments
  if (canViewProjects.value) {
    projectFilters.value.facility = entity.value?.id
    projectFilters.value.status = "Finalized,Completed"
    projectPaging.value.itemsPerPage = 25
  }
}

const localDeleteFacilityContactAsync = async (c) => {
  if (!canChange.value) {
    return
  }
  await deleteFacilityContactAsync(fetchAuthAsync, c)
  await loadEntityAsync()
}

const localSaveFacilityContactAsync = async (contact) => {
  if (!canChange.value) {
    return
  }
  await saveFacilityContactAsync(fetchAuthAsync, contact, entity.value)
  facilityContact.value = {}
  await loadEntityAsync()
}

const saveDeviceDatesAsync = async () => {
  await Promise.all(entity.value.devices.map((device) => saveEntityAsync(fetchAuthAsync, "Devices", device, false)))
}

const saveAsync = async () => {
  if (!canChange.value) {
    return
  }
  const result = await saveEntityAsync(fetchAuthAsync, "Facility", entity.value, isNew.value)
  if (!result) return
  if (isNew.value) {
    router.push({ name: "FacilityEdit", params: { facilityId: entity.value.id, keepMessages: true } })
  } else {
    await loadEntityAsync()
  }
}

watch(
  () => route.params.facilityId,
  () => loadEntityAsync(),
)

watch(
  () => ({ ...projectFilters.value }),
  () => {
    if (!canViewProjects.value) {
      return
    }
    resetProjectPaging() // will also fire getOrdersAsync()
  },
)

watch(canViewProjects, (enabled) => {
  if (!enabled) {
    projects.value = []
  }
})

onMounted(async () => {
  await loadEntityAsync()
  await loadEnumsAsync()
})
</script>
